/* swt-header-brands.js · SWT Header v3.0 tabbed menus (Brands + Accessories). Vanilla JS.
   A module for swt-header.js (registered on window.SWTHeaderModules, so this
   file must load before swt-header.js; it runs again when the theme editor
   reloads the section). Markup: snippets/swt-header-brands.liquid. Every
   [data-swt-brands] panel in the header is bound on its own (Brands = Brand
   tab blocks, Accessories = the menu's own links).
   Tabs: mouse hover switches after 90ms (a quick pass over other tabs does
   nothing), keyboard focus or click switches at once; a click on the shown
   tab opens the collection. Touch: first tap shows the tab, second opens it.
   Only the shown tab is in the Tab order; Up/Down arrows move through every
   visible link and button in the menu. Theme editor: selecting a Brand tab
   block opens the menu on that tab.
   All brands (Brands only): the button swaps the product area for the A-Z
   logo grid (same grid cell, so the menu keeps its height). The back arrow,
   the button again, or hovering / focusing any tab brings the products back.
   The menu opens on the products again next time. v2.7: the logos start
   loading when the pointer or focus reaches the button, so they are ready
   by the time it is clicked.
   Products (v3.0, 10-09-26): panes not filled on the server fetch
   /collections/[handle]?sort_by=[data-sort]&section_id=swt-mega-products
   (data-sort = the header's "Menu products order", default
   created-descending = newest first). The feed sends the collection's Menu
   picks first (data-pin), then the collection in that order, add-ons and
   sold-out items already left out. Kept: picks first, then product types in
   data-types when it is set, then any other card; cached per collection +
   order + type list (memory + 10 minutes in sessionStorage). Pinned cards
   the server already rendered (Brand tab "Pinned products") stay first and
   the fetched cards fill the rest, without repeats, up to 5.
   The shown tab is fetched as soon as the pointer or focus reaches its nav
   item; once that menu has opened, its other tabs load one after another in
   the background. Their images wait until the tab is hovered or shown.
   v2.5.1: a failed fetch is retried once on its own after 1.5s; if that
   fails too, a short message shows and it is tried again the next time
   that tab is shown. */
(function () {
  'use strict';
  var TAB_DELAY = 90, KEEP = 5, POOL = 10, TTL = 600000, KEY = 'swt-bm-v3:', RESET_DELAY = 300, RETRY_DELAY = 1500;
  var mem = {};

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }
  function cacheKey(handle, types, sort) {
    var S = window.Shopify || {};
    return KEY + (S.country || '') + '-' + ((S.currency && S.currency.active) || '') + ':' + sort + ':' + types.join('|') + ':' + handle;
  }
  function readCache(k) {
    try {
      var o = JSON.parse(sessionStorage.getItem(k) || 'null');
      return o && Date.now() - o.t < TTL ? o.h : null;
    } catch (e) { return null; }
  }
  function writeCache(k, html) {
    try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), h: html })); } catch (e) {}
  }

  /* keep the best 10 cards from the fetched section: picks, then type matches, then the rest */
  function pick(html, types) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var pin = [], hit = [], rest = [];
    Array.prototype.forEach.call(doc.querySelectorAll('.swt-bm__card'), function (c) {
      if (c.hasAttribute('data-pin')) { pin.push(c); return; }
      var t = (c.getAttribute('data-type') || '').toLowerCase().trim();
      (!types.length || types.indexOf(t) > -1 ? hit : rest).push(c);
    });
    return pin.concat(hit, rest).slice(0, POOL).map(function (c) { return c.outerHTML; }).join('');
  }

  /* one fetch of a feed; rejects on a bad status or a page without the feed */
  function get(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (html.indexOf('swt-bm__feed') < 0) throw new Error('no feed');
        return html;
      });
  }

  function load(handle, types, sort) {
    var k = cacheKey(handle, types, sort);
    if (mem[k]) return mem[k];
    var cached = readCache(k);
    var url = root() + 'collections/' + encodeURIComponent(handle) + '?sort_by=' + encodeURIComponent(sort) + '&section_id=swt-mega-products';
    var p = cached !== null ? Promise.resolve(cached) :
      get(url)
        .catch(function () {
          return new Promise(function (res) { setTimeout(res, RETRY_DELAY); }).then(function () { return get(url); });
        })
        .then(function (html) {
          var keep = pick(html, types);
          writeCache(k, keep);
          return keep;
        });
    mem[k] = p.catch(function (err) { delete mem[k]; throw err; });
    return mem[k];
  }

  /* links + buttons a keyboard user can reach right now, in page order */
  function reachable(bm) {
    return Array.prototype.filter.call(bm.querySelectorAll('a[href], button:not([disabled])'), function (el) {
      return !el.closest('[inert]') && el.getClientRects().length > 0;
    });
  }

  function bind(bm, ctx) {
    var li = bm.closest('[data-swt-item]');
    var sig = ctx.sig;
    var types = (bm.getAttribute('data-types') || '').toLowerCase().split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);
    var sort = bm.getAttribute('data-sort') || 'created-descending';
    var tabs = Array.prototype.slice.call(bm.querySelectorAll('[data-swt-tab]'));
    if (!tabs.length) return null;
    var active = bm.querySelector('.swt-bm__tab.is-active') || tabs[0];
    var az = bm.querySelector('[data-swt-az]');
    var azBtn = bm.querySelector('[data-swt-az-open]');
    var azBack = bm.querySelector('[data-swt-az-back]');
    var hoverT = 0, tabbingT = 0, resetT = 0, queued = false, lastPointer = 'mouse', mo = null;

    function paneOf(tab) {
      return tab ? bm.querySelector('[data-swt-pane="' + tab.getAttribute('data-swt-tab') + '"]') : null;
    }
    function isOpen() { return !!li && li.classList.contains('is-open'); }
    function isAz() { return !!az && bm.classList.contains('is-az'); }

    /* swap waiting images in (a pane, or the logo grid) */
    function showImages(pane) {
      if (!pane) return;
      pane.querySelectorAll('img[data-bm-src]').forEach(function (img) {
        img.src = img.getAttribute('data-bm-src');
        img.removeAttribute('data-bm-src');
      });
    }

    /* play the rise-in on el (a pane, the logo grid, or a pane's card row) */
    function enter(el) {
      el.classList.add('is-enter');
      void el.offsetWidth;
      requestAnimationFrame(function () { el.classList.remove('is-enter'); });
    }
    function tabbing() {
      bm.classList.add('is-tabbing');
      clearTimeout(tabbingT);
      tabbingT = setTimeout(function () { bm.classList.remove('is-tabbing'); }, 700);
    }
    function hide(el) {
      el.classList.remove('is-active');
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
    }
    function reveal(el) {
      el.removeAttribute('inert');
      el.removeAttribute('aria-hidden');
      el.classList.add('is-active');
    }

    function setMsg(pane, state) {
      pane.setAttribute('data-state', state);
      var m = pane.querySelector('[data-swt-msg]');
      if (m) m.textContent = state === 'error' ? 'Products did not load. Try again in a moment.' : state === 'empty' ? 'Nothing in stock right now.' : '';
    }

    /* pinned cards from the server stay first; fetched cards fill the rest (no repeats, 5 in all) */
    function fill(pane, html) {
      var box = pane.querySelector('[data-swt-cards]');
      if (!box) return;
      var shown = pane.classList.contains('is-active') && isOpen();
      if (shown) box.classList.add('is-enter');
      var kept = Array.prototype.filter.call(box.querySelectorAll('.swt-bm__card[data-pin]'), function (c) {
        return !c.classList.contains('swt-bm__card--ghost');
      });
      var have = {};
      kept.forEach(function (c) { have[c.getAttribute('href')] = 1; });
      box.querySelectorAll('.swt-bm__card').forEach(function (c) {
        if (kept.indexOf(c) < 0) c.remove();
      });
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var msg = box.querySelector('[data-swt-msg]');
      var room = KEEP - kept.length, added = 0;
      Array.prototype.slice.call(tmp.children).forEach(function (c) {
        var h = c.getAttribute('href');
        if (added >= room || have[h]) return;
        have[h] = 1;
        c.style.setProperty('--i', kept.length + added);
        if (!pane.classList.contains('is-active')) {
          c.querySelectorAll('img[src]').forEach(function (img) {
            img.setAttribute('data-bm-src', img.getAttribute('src'));
            img.removeAttribute('src');
          });
        }
        box.insertBefore(c, msg);
        added++;
      });
      setMsg(pane, kept.length + added ? 'ready' : 'empty');
      if (shown) {
        void box.offsetWidth;
        requestAnimationFrame(function () { box.classList.remove('is-enter'); });
      }
    }

    /* make sure a pane has its products; resolves when done (never rejects) */
    function ensure(pane) {
      if (!pane) return Promise.resolve();
      var st = pane.getAttribute('data-state');
      if (st === 'ready' || st === 'empty' || st === 'loading') return Promise.resolve();
      pane.setAttribute('data-state', 'loading');
      return load(pane.getAttribute('data-handle'), types, sort)
        .then(function (html) { fill(pane, html); })
        .catch(function () { setMsg(pane, 'error'); });
    }

    function queueRest() {
      if (queued) return;
      queued = true;
      var chain = Promise.resolve();
      tabs.forEach(function (t) {
        var p = paneOf(t);
        chain = chain.then(function () {
          return new Promise(function (res) { setTimeout(res, 120); });
        }).then(function () { return ensure(p); });
      });
    }

    /* tab looks: none looks chosen while the logo grid is shown */
    function markTabs() {
      var inAz = isAz();
      tabs.forEach(function (t) {
        var on = t === active;
        t.classList.toggle('is-active', on);
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && !inAz) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }

    function showPane(pane, old) {
      if (old && old !== pane) hide(old);
      showImages(pane);
      tabbing();
      reveal(pane);
      enter(pane);
      if (pane.getAttribute('data-state') === 'error') pane.removeAttribute('data-state');
      ensure(pane);
    }

    function setAz(on) {
      bm.classList.toggle('is-az', on);
      if (azBtn) azBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function activate(tab) {
      if (!tab) return;
      var inAz = isAz();
      if (tab === active && !inAz) return;
      var pane = paneOf(tab);
      if (!pane) return;
      var old = inAz ? az : paneOf(active);
      active = tab;
      if (inAz) setAz(false);
      markTabs();
      showPane(pane, old);
    }

    function openAz() {
      if (!az || isAz()) return;
      var old = paneOf(active);
      clearTimeout(hoverT);
      setAz(true);
      markTabs();
      if (old) hide(old);
      showImages(az);
      tabbing();
      reveal(az);
      enter(az);
    }

    /* back to the shown tab's products. Focus inside the grid moves to the
       All brands button first, so the menu never loses focus (and closes). */
    function closeAz(quiet) {
      if (!isAz()) return;
      var pane = paneOf(active);
      if (azBtn && az.contains(document.activeElement)) azBtn.focus();
      setAz(false);
      markTabs();
      if (!pane) { hide(az); return; }
      if (quiet) {
        hide(az);
        reveal(pane);
        ensure(pane);
      } else {
        showPane(pane, az);
      }
    }

    /* warm-up: fetch the shown tab before the menu opens */
    function warm() { ensure(paneOf(active)); }
    if (li) {
      li.addEventListener('pointerenter', warm, sig);
      li.addEventListener('focusin', warm, sig);
      li.addEventListener('swt:menu:firstopen', function () { warm(); queueRest(); }, sig);
    }

    bm.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, sig);

    tabs.forEach(function (tab) {
      tab.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        var p = paneOf(tab);
        showImages(p);
        ensure(p);
        clearTimeout(hoverT);
        hoverT = setTimeout(function () { activate(tab); }, TAB_DELAY);
      }, sig);
      tab.addEventListener('pointerleave', function () { clearTimeout(hoverT); }, sig);
      tab.addEventListener('focus', function () { activate(tab); }, sig);
      tab.addEventListener('click', function (e) {
        if (tab === active && !isAz()) return;
        if (lastPointer === 'touch') { e.preventDefault(); clearTimeout(hoverT); activate(tab); return; }
        activate(tab);
      }, sig);
    });

    if (az && azBtn) {
      /* logos load on the way to the button, not with the page */
      azBtn.addEventListener('pointerenter', function () { showImages(az); }, sig);
      azBtn.addEventListener('focus', function () { showImages(az); }, sig);
      azBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (isAz()) closeAz(); else openAz();
      }, sig);
      if (azBack) azBack.addEventListener('click', function (e) {
        e.preventDefault();
        closeAz();
      }, sig);
      /* menu closed: show products again next time it opens */
      if (li && 'MutationObserver' in window) {
        mo = new MutationObserver(function () {
          clearTimeout(resetT);
          if (isOpen() || !isAz()) return;
          resetT = setTimeout(function () { if (!isOpen()) closeAz(true); }, RESET_DELAY);
        });
        mo.observe(li, { attributes: true, attributeFilter: ['class'] });
      }
    }

    /* Up / Down arrows: every reachable link and button in the menu, in order */
    bm.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var els = reachable(bm);
      var i = els.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      e.stopPropagation();
      var next = els[e.key === 'ArrowDown' ? Math.min(i + 1, els.length - 1) : Math.max(i - 1, 0)];
      if (next) next.focus();
    }, sig);

    /* theme editor: selecting a Brand tab block shows it */
    document.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      var tab = id ? bm.querySelector('[data-swt-tab="' + id + '"]') : null;
      if (!tab) return;
      activate(tab);
      if (!isOpen() && li) li.dispatchEvent(new PointerEvent('pointerenter', { pointerType: 'mouse' }));
    }, sig);

    return function () {
      clearTimeout(hoverT); clearTimeout(tabbingT); clearTimeout(resetT);
      if (mo) mo.disconnect();
    };
  }

  var mods = window.SWTHeaderModules = window.SWTHeaderModules || [];
  mods.push(function (ctx) {
    var cleanups = [];
    Array.prototype.forEach.call(ctx.root.querySelectorAll('[data-swt-brands]'), function (bm) {
      var c = bind(bm, ctx);
      if (c) cleanups.push(c);
    });
    if (!cleanups.length) return;
    return function () { cleanups.forEach(function (c) { c(); }); };
  });
})();
